(() => {
  if (customElements.get('unit-switch')) {
    return;
  }

  class UnitSwitch extends HTMLElement {
    constructor() {
      super();
      this.toggles = document.querySelectorAll('.inc-cm-number');
      this.units = this.querySelectorAll('span[data-unit]');
    }

    connectedCallback() {
      this.addEventListener('click', (event) => {
        const active = this.querySelector('span[data-unit].active');
        const notActive = this.querySelector('span[data-unit]:not(.active)');
        const notActiveVal = notActive.dataset.unit;

        active.classList.remove('active');
        notActive.classList.add('active');

        const values = document.querySelectorAll('.inc-cm-number');

        values.forEach(val => {
          var dataValue = val.getAttribute(`data-${notActiveVal}`);
          val.innerText = dataValue;
        });
      });
    }
  }

  customElements.define('unit-switch', UnitSwitch);
})();
